import React from "react";

export const NeuralBackground: React.FC = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Ambient Neural Pathways */}
      <svg
        className="absolute inset-0 w-full h-full opacity-20"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="neuralGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity="0.8" />
            <stop offset="50%" stopColor="hsl(var(--accent))" stopOpacity="0.6" />
            <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity="0.4" />
          </linearGradient>
          
          <radialGradient id="neuralGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity="0.3" />
            <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity="0" />
          </radialGradient>
        </defs>
        
        {/* Background Neural Network */}
        <g className="animate-pulse" style={{ animationDuration: '4s' }}>
          <path
            d="M 0,50 Q 25,20 50,50 T 100,30"
            stroke="url(#neuralGradient)"
            strokeWidth="0.5"
            fill="none"
            opacity="0.3"
          />
          <path
            d="M 0,30 Q 30,70 60,40 T 100,60"
            stroke="url(#neuralGradient)"
            strokeWidth="0.3"
            fill="none"
            opacity="0.4"
          />
          <path
            d="M 0,70 Q 40,10 70,70 T 100,40"
            stroke="url(#neuralGradient)"
            strokeWidth="0.4"
            fill="none"
            opacity="0.2"
          />
        </g>
      </svg>
      
      {/* Floating Neural Particles */}
      <div className="absolute inset-0">
        {Array.from({ length: 20 }).map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-primary/20 rounded-full animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${3 + Math.random() * 4}s`
            }}
          />
        ))}
      </div>
      
      {/* Neural Synaptic Bursts */}
      <div className="absolute inset-0">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 rounded-full animate-neural-pulse"
            style={{
              left: `${20 + Math.random() * 60}%`,
              top: `${20 + Math.random() * 60}%`,
              animationDelay: `${Math.random() * 3}s`,
              background: `radial-gradient(circle, hsl(var(--${i % 2 === 0 ? 'primary' : 'accent'}) / 0.6) 0%, transparent 70%)`
            }}
          />
        ))}
      </div>
      
      {/* Central Neural Hub Glow */}
      <div 
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full opacity-10 animate-pulse"
        style={{
          background: 'radial-gradient(circle, hsl(var(--primary)) 0%, transparent 70%)',
          animationDuration: '6s'
        }}
      />
    </div>
  );
};